module.exports = __webpack_public_path__ + "img/Icon awesome-long-arrow-alt-left.7e37eefc.svg";